
define('modules/application/wizard/steps',[
    "app",

    // Libs
    "backbone",
    "jqueryUi",

    //Class
    "./steps/regularStep",
    "./steps/systemChoices",
    "./steps/systemChoices/thermoSystemChoices",
    "./steps/systemChoices/intrusionDetectionSystemChoices",
    "./steps/systemChoices/audioVideoSystemChoices",
    "./steps/systemChoices/automationSystemChoices",
    "./steps/systemChoices/automationSimpleSystemChoices",
    "./steps/systemChoices/energyManagementSystemChoices",
    "./steps/zoneStep/thermoZoneStep",
    "./steps/zoneStep/complexZoneStep/intrusionDetectionZoneStep",
    "./steps/zoneStep/complexZoneStep/audioVideoZoneStep",
    "./steps/zoneStep/complexZoneStep/automationZoneStep",
    "./steps/zoneStep/complexZoneStep/automationSimpleZoneStep",
    "./steps/zoneStep/complexZoneStep/energyManagementZoneStep",
    "./steps/materialOverview/thermoregulationMaterialOverview",
    "./steps/materialOverview/intrusionDetectionMaterialOverview",
    "./steps/materialOverview/audioVideoMaterialOverview",
    "./steps/materialOverview/automationMaterialOverview",
    "./steps/materialOverview/automationSimpleMaterialOverview",
    "./steps/materialOverview/energyManagementMaterialOverview",
    "./steps/configurationOverview",
    "./steps/exportStep"
  ],

  function(app, Backbone, jQueryUi,
    regularStep,
    systemChoices,
    thermoSystemChoices,
    intrusionDetectionSystemChoices,
    audioVideoSystemChoices,
    automationSystemChoices,
    automationSimpleSystemChoices,
    energyManagementSystemChoices,
    thermoZoneStep,
    intrusionDetectionZoneStep,
    audioVideoZoneStep,
    automationZoneStep,
    automationSimpleZoneStep,
    energyManagementZoneStep,
    thermoregulationMaterialOverview,
    intrusionDetectionMaterialOverview,
    audioVideoMaterialOverview,
    automationMaterialOverview,
    automationSimpleMaterialOverview,
    energyManagementMaterialOverview,
    configurationOverview,
    exportStep) {

    var Steps = app.module();

    Steps.stepInstancer = function(step) {
      var toReturn;
      switch (step) {
      case "regular":
        toReturn = regularStep;
        break;

      case "thermoSystemChoices":
        toReturn = thermoSystemChoices;
        break;

      case "intrusionDetectionSystemChoices":
        toReturn = intrusionDetectionSystemChoices;
        break;

      case "audioVideoSystemChoices":
        toReturn = audioVideoSystemChoices;
        break;

      case "automationSystemChoices":
        toReturn = automationSystemChoices;
        break;

      case "automationSimpleSystemChoices":
        toReturn = automationSimpleSystemChoices;
        break;

      case "energyManagementSystemChoices":
        toReturn = energyManagementSystemChoices;
        break;

      case "thermoZones":
        toReturn = thermoZoneStep;
        break;

      case "intrusionDetectionZones":
        toReturn = intrusionDetectionZoneStep;
        break;

      case "audioVideoZones":
        toReturn = audioVideoZoneStep;
        break;

      case "automationZones":
        toReturn = automationZoneStep;
        break;

      case "automationSimpleZones":
        toReturn = automationSimpleZoneStep;
        break;

      case "energyManagementZones":
        toReturn = energyManagementZoneStep;
        break;

      case "materialOverview":
        toReturn = materialOverview;
        break;

      case "thermoregulationMaterialOverview":
        toReturn = thermoregulationMaterialOverview;
        break;

      case "intrusionDetectionMaterialOverview":
        toReturn = intrusionDetectionMaterialOverview;
        break;

      case "audioVideoMaterialOverview":
        toReturn = audioVideoMaterialOverview;
        break;

      case "automationMaterialOverview":
        toReturn = automationMaterialOverview;
        break;

      case "automationSimpleMaterialOverview":
        toReturn = automationSimpleMaterialOverview;
        break;

      case "energyManagementMaterialOverview":
        toReturn = energyManagementMaterialOverview;
        break;

      case "configurationOverview":
        toReturn = configurationOverview;
        break;

      case "export":
        toReturn = exportStep;
        break;
      }
      return toReturn;
    };

    Steps.Collection = Backbone.Collection.extend({
      initialize: function() {
        this.systemAppName = window.BticinoS4B.Instances.Models.ApplicationModel.get("systemAppName");
        this.fetch();
      },

      url: function() {
        return "/config/" + this.systemAppName + ".js";
      },


      fetch: function() {
        return Backbone.Collection.prototype.fetch.call(this, {
          async: false
        });
      }
    });

    Steps.Views.Tabs = Backbone.View.extend({

      template: "application/wizard/steps/tab",
      tagName: "div",
      className: "tabs",
      disabled: [1, 2, 3, 4],
      stepEventAggregator: _.extend({}, Backbone.Events),

      initialize: function() {
        var that = this;
        var stepEventAggregator;

        this.tabViews = [];
        this.contentViews = [];

        window.BticinoS4B.eventAggregator.bind("zoneStep:show", function() {
          that.$el.tabs("select", 1);
        });

        window.BticinoS4B.eventAggregator.bind("load:Project", function() {
          that.$el.tabs("select", 0);
        });

        _.each(this.collection.models, function(step) {
          that.tabViews = [];
          that.contentViews = [];

          stepEventAggregator = _.extend({}, Backbone.Events);

          stepEventAggregator.bind('step:validated', function(currentModel) {
            that.enableSteps(currentModel.get("sectionsToEnableAfterValidation"));
          });

          stepEventAggregator.bind('step:unvalidated', function(currentModel) {
            that.disableSteps(currentModel.get("sectionsToDisableAfterUnvalidation"));
          });

          var classToInstance = Steps.stepInstancer(step.get("class"));
          var obj = classToInstance;
          step.attributes.stepEventAggregator = stepEventAggregator;
          var objModel = new obj.Model(step.attributes);

          var tabView = new obj.Views.Tab({
            model: objModel,
            stepEventAggregator: stepEventAggregator
          });

          var contentView = new obj.Views.Content({
            model: objModel,
            stepEventAggregator: stepEventAggregator,
            id: step.get("name")
          });

          this.tabViews.push(tabView);
          this.contentViews.push(contentView);

          for (var i = 0; i < this.tabViews.length; i++) {
            this.insertView("#stepList", this.tabViews[i]);
            this.insertView(this.contentViews[i]);
          }

        }, this);
      },

      serialize: function() {
        return {
          collection: this.collection
        };
      },

      enableSteps: function(sectionsToEnable) {
        if (sectionsToEnable)
          for (var i = 0; i < sectionsToEnable.length; i++)
            if (this.$el.data("tabs"))
              this.$el.tabs("enable", sectionsToEnable[i]);
        this.disabled = _.difference(this.disabled, sectionsToEnable);
      },

      disableSteps: function(sectionsToDisable) {
        if (sectionsToDisable)
          for (var i = 0; i < sectionsToDisable.length; i++)
            if (this.$el.data("tabs"))
              this.$el.tabs("disable", sectionsToDisable[i]);
        this.disabled = _.union(this.disabled, sectionsToDisable);
      },

      beforeRender: function() {
        this.selectedTab = this.$el.tabs("option", "selected");
      },

      afterRender: function() {
        var that = this;
        if (this.$el.data("tabs"))
          this.$el.tabs('destroy');

        this.$el.tabs({
          disabled: this.disabled,
          selected: this.selectedTab,
          activate: function(event, ui) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
        
        this.$el.bind("tabsshow", function(event, ui) {
          //
          if (window.BticinoS4B.vars.system /*&& window.BticinoS4B.vars.system.kitCode*/) { //tmp
            window.BticinoS4B.eventAggregator.trigger("addAdditionalElementsToKit", that);
          }

          //If the zone setup tab has been selected
          if (ui.index == 1) {
            window.BticinoS4B.eventAggregator.trigger("accessoryLine:confirmed", that);
            window.BticinoS4B.eventAggregator.trigger("zoneDetail:render", that);
          }

          //If the material overview tabs has been selected
          if (ui.index == 2)
            window.BticinoS4B.eventAggregator.trigger("materialsOverview:requested", that);

          //If the configuration overview tabs has been selected
          if (ui.index == 3)
            window.BticinoS4B.eventAggregator.trigger("configurationOverview:requested", that);
        });
      }
    });

    Steps.Views.TabsItem = Backbone.View.extend({

      template: "application/wizard/steps/tabs-item",
      tagName: "li",

      serialize: function() {
        return {
          model: this.model
        };
      },

      cleanup: function() {
        this.model.off(null, null, this);
      },

      afterRender: function() {
        setTimeout(function() {
          window.customizeFormElements.call();
        }, 0);
      }

    });


    // Required, return the module for AMD compliance
    return Steps;
  });